module.exports = __webpack_public_path__ + "static/media/SANATAN_3D001 .1751838d.jpg";